function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.669 0.65918C18.07 0.65918 19.99 2.58818 20 5.98918V15.3292C20 18.7292 18.07 20.6592 14.669 20.6592H5.33C1.929 20.6592 0 18.7292 0 15.3292V5.98918C0 2.58818 1.929 0.65918 5.33 0.65918H14.669ZM17 17.0002H14.4975C14.4975 11.2059 9.785 6.49286 4 6.49286V4.00016C11.1663 4.00016 17 9.83571 17 17.0002ZM12.58 17.0002H10.0775C10.0786 16.1978 9.92174 15.4032 9.61617 14.6633C9.31059 13.9234 8.86246 13.253 8.29813 12.6916C7.14437 11.5443 5.625 10.9087 4 10.9087V8.41603C8.72875 8.41603 12.58 12.2706 12.58 17.0002ZM7.46125 15.2586C7.46125 16.216 6.68125 16.9837 5.73063 16.9837C4.77187 16.9837 4 16.216 4 15.2586C4 14.3094 4.77187 13.5335 5.73063 13.5335C6.68125 13.5335 7.46125 14.3094 7.46125 15.2586Z",
  fill: "white"
});

var SvgIcFollower = function SvgIcFollower(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcFollower, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_follower.b38de01d.svg";
export { ForwardRef as ReactComponent };